var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "article",
    {
      staticClass:
        "analyses-online-order-benefit d-flex flex-column align-center ga-4 ga-sm-6 min-w-0",
      class: { "analyses-online-order-benefit--spaced": _vm.spaced },
      attrs: { "data-qa": "analyses_online_order_benefit" },
    },
    [
      _c("div", { staticClass: "d-flex align-start ga-4 w-100 min-w-0" }, [
        _c(
          "div",
          {
            staticClass: "analyses-online-order-benefit__number flex-shrink-0",
            attrs: { "aria-hidden": "true" },
          },
          [_vm._v("\n      " + _vm._s(_vm.number) + "\n    ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column gr-1 min-w-0 mt-3" }, [
          _c("h3", { staticClass: "text-subtitle-1 text--text mb-0" }, [
            _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-body-1 text-secondary--text mb-0" }, [
            _vm._v("\n        " + _vm._s(_vm.description) + "\n      "),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass:
          "analyses-online-order-benefit__illustration flex-shrink-0",
        class: `analyses-online-order-benefit__illustration_${_vm.illustrationModifier}`,
        attrs: { src: _vm.image, alt: "" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }